/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { defineMessages } from 'react-intl';

import { FormatMessageType, SortDirection } from 'CommonTypes';
import { TableViewType, MonitorFilterType, PALFilterType } from 'TableTypes';

const messages = defineMessages({
  ascending: 'ascending',
  descending: 'descending',
  columnsLength: 'Columns: {length}',
  filtersLength: 'Filters: {length}',
  search: 'Search: {value}',
  sort: 'Sort: {value}',
});
/**
 * Returns a formatted string with the current columns, filters, and search value of the table view
 */
export const getDescription = (view: TableViewType, formatMessage: FormatMessageType): string => {
  const sortText = view?.table?.sort?.columnId
    ? `${view?.table?.sort?.columnId} ${
        view?.table?.sort?.direction === SortDirection.ASC
          ? formatMessage(messages.ascending)
          : formatMessage(messages.descending)
      }`
    : '';
  return `${formatMessage(messages.columnsLength, {
    length: view.columns.length,
  })}, ${formatMessage(messages.filtersLength, {
    length: Object.keys(view.filters).length || 0,
  })}, ${formatMessage(messages.search, { value: view.searchValue })}, ${formatMessage(
    messages.sort,
    { value: sortText }
  )}`;
};

/**
 * Formats and returns the monitor API version of filters into the PAL format for render
 */
export const mapToPALFilters = (monitorFilters: MonitorFilterType): PALFilterType =>
  Object.entries(monitorFilters || {}).map(([key, value]) => ({
    columnId: key,
    value,
  }));
